export default __webpack_public_path__ + "static/sustainability-53f0be41859d5a3ad7e99ef25b43cb74.webp";